export default __webpack_public_path__ + "static/media/profile.a9d5e5ac.svg";